/**
 * 问卷 Q07「下一阶段培养与发展的重点」勾选项。
 * `name` 须与业务方定型稿逐字一致；非经业务方授权勿在仓库内改写文案。
 */
export const Q07_HP_DEVELOP_PATHS = [
  {
    code: 'MGMT_COMPLEX',
    name: '提升管理复杂度（扩大管理幅面 / 统筹多店 / 多职能）',
  },
  {
    code: 'CROSS_KEY_PROJECT',
    name: '牵头跨店 / 跨部门重点项目（打造横向影响力）',
  },
  {
    code: 'EXPERT_DEPTH',
    name: '在专业上继续深耕，成为领域专家 / 业务骨干',
  },
  {
    code: 'INNOVATION_PILOT',
    name: '试跑新品项、新渠道、新机制（开拓创新，做造浪者）',
  },
  {
    code: 'KEY_ROLE_ROTATION',
    name: '承接核心岗位 / 关键角色历练（向更高层级岗位过渡）',
  },
  {
    code: 'SKILL_PROGRAM',
    name: '专项能力赋能（如领导力、内训师、战略思维等）',
  },
  { code: 'OTHER', name: '其他（写清建议方向）' },
] as const;
